<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-file-remove-outline
          </v-icon>
          JWNET未加入業者
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.code"
                        dense
                        hide-details="auto"
                        label="事業者コード"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.code = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.companyName"
                        dense
                        hide-details="auto"
                        label="事業者名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.companyName = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.subscriberType"
                        :items="subscriberTypes"
                        clearable
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="業者区分"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 100%"
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.locationName"
                        dense
                        hide-details="auto"
                        label="事業場名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.locationName = null; searchButtonClickEvent()"
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="searchForm.unregisterLocation"
                        dense
                        hide-details="auto"
                        label="事業場警告のみ表示"
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->
    <v-row>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          JWNET未加入業者の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat class="rounded-card">
          <v-data-table
            :headers="tableHeaders"
            :items="non_subscribe_traders"
            :items-per-page="-1"
            hide-default-footer
            disable-pagination
            disable-sort
          >
            <!-- コード/加入者番号 -->
            <template v-slot:[`item.code`]="{ item }">
              <div>
                {{ item.code }}
              </div>
            </template>
            <!-- /コード/加入者番号 -->

            <template v-slot:[`item.name`]="{ item }">
              <span :title="item.name">{{ item.name | truncate(15) }}</span>
            </template>
            <template v-slot:[`item.subscriber_type`]="{ item }">
              {{ item.subscriber_type | subscriber_type_to_label }}
            </template>
            <template v-slot:[`item.permit_number`]="{ item }">
              <div>
                {{ item.permit_number }}
              </div>
            </template>
            <template v-slot:[`item.address`]="{ item }">
              <span>{{ item.address | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.recycle_registered`]="{ item }">
              <v-icon
                v-if="!item.permit_number && item.subscriber_type === 'disposer_type'"
                color="red"
              >
                mdi-block-helper
              </v-icon>
            </template>

            <template v-slot:[`item.location_registered`]="{ item }">
              <v-icon
                v-if="!item.location_registered"
                color="red"
              >
                mdi-block-helper
              </v-icon>
            </template>

            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                icon
                color="info darken-2"
                @click="showButtonClickEvent(item)"
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="info"
                @click="showButtonClickEvent(item)"
              >
                参照
              </v-btn>
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                color="info darken-2"
                icon
                @click="editButtonClickEvent(item)"
              >
                <v-icon>mdi-note-edit</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="info"
                @click="editButtonClickEvent(item)"
              >
                編集
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
  </v-container>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import CustomPagination from "@/driver/components/_CustomPagination.vue";

export default {
  name: 'DriverMasterNonSubscribeTraderIndex',
  components: {
    CustomPagination
  },
  filters: {
  },
  mixins: [
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      searchForm: {
        code: null,
        companyName: null,
        subscriberType: null,
        locationName: null,
        unregisterLocation: false,
      },
      withDeleted: false,
      tableHeaders: [
        { text: '事業者コード', value: 'code' },
        { text: '事業者名', value: 'name' },
        { text: '業者区分', value: 'subscriber_type' },
        { text: '許可番号', value: 'permit_number' },
        { text: '住所', value: 'address' },
        { text: '再資源化利用', value: 'recycle_registered', align: 'center' },
        { text: '事業場警告', value: 'location_registered', align: 'center' },
        { text: '詳細・編集', value: 'editable', align: 'end' },
      ],
      non_subscribe_traders: [],
      /** 最終報告状況 */
      subscriberTypes: [
        { value: 'transport_type', text: '収集運搬業者' },
        { value: 'disposer_type', text: '処分業者' },
      ],
    }
  },
  /**
   * @property isDemoEnv { boolean }
   */
  computed: {
    ...mapState('DriverMasterNonSubscribeTrader', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
    }),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }

    this.searchForm.code = this.searchCondition.code
    this.searchForm.companyName = this.searchCondition.name
    this.searchForm.subscriberType = this.searchCondition.subscriber_type
    this.searchForm.locationName = this.searchCondition.location_name
    this.searchForm.unregisterLocation = this.searchCondition.unregister_location
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchNonSubscribeTraders()
  },
  methods: {
    ...mapActions('DriverMasterNonSubscribeTrader', {
      fetchNonSubscribeTraders: 'index',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    searchButtonClickEvent () {
      this.page = 1
      this.searchNonSubscribeTraders()
    },
    addButtonClickEvent () {
      this.$router.push({name: 'DriverMasterNonSubscribeTraderNew'})
    },
    showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterNonSubscribeTrader', params: { id: item.id }})
    },
    editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterNonSubscribeTraderEdit', params: {id: item.id }})
    },
    changePage(page) {
      this.page = page;
      this.searchNonSubscribeTraders()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchNonSubscribeTraders()
    },
    searchNonSubscribeTraders () {
      let params = this.buildParam('json')
      this.fetchNonSubscribeTraders(params).then((content) => {
        this.non_subscribe_traders = content.traders
      })
    },
    buildParam (format) {
      return {
        code: this.searchForm.code,
        name: this.searchForm.companyName,
        subscriber_type: this.searchForm.subscriberType,
        location_name: this.searchForm.locationName,
        unregister_location: this.searchForm.unregisterLocation,
        page: this.page,
        limit: this.perPage,
        format: format
      }
    },
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
